import React, { useEffect, useState } from 'react';
import { Col, Row, Collapse, Button } from 'reactstrap';

import { MIND_PATTERNS_DATA_AREAS, MIND_PATTERNS_DATA_REPORTS } from '../../../core/constants';
import ReportTT from '../../components/community/Report-tt';
import { getMindPatternsDataById, mindPatternsDataActions } from '../../../core/mind-patterns';
import { useDispatch, useSelector } from 'react-redux';
import icon_team_leader from '../../../assets/img/icon-team-leader.svg';
import { Link } from 'react-router-dom';

export const ResumeMember = (props) => {
    const dispatch = useDispatch();
    const { user, isLeader } = props;
    const loggedUser = useSelector(state => state.user);
    const reports = useSelector(state => getMindPatternsDataById(state, MIND_PATTERNS_DATA_REPORTS));
    const mindPatternsAreas = useSelector(state => getMindPatternsDataById(state, MIND_PATTERNS_DATA_AREAS));
    const [textReport, setTextReport] = useState('');
    const [collapsed, setCollapsed] = useState(true);
    const toggleCollapsed = () => { setCollapsed(!collapsed) }

    const mind_pattern = user.mind_pattern
    const first_name = user.first_name
    const last_name = user.last_name
    const rol = user.seniority && user.seniority.name ? user.seniority.name : ''
    const email = user.email
    const avatar = user.avatar
    const hasNoTalents = user &&
        (!user?.talents ||
            user.talents?.length === 0 ||
            user.talents?.every(quadrant => quadrant.items?.length === 0));

    useEffect(() => {
        const currentReport = reports?.items?.find?.(report => report.code === loggedUser.mind_pattern);
        const userReport = reports?.items?.find?.(report => report.code === user.mind_pattern)

        const defaultTextReport = userReport?.feature_summary || '';
        const currentTextReport = (currentReport && loggedUser?.mind_pattern && user.mind_pattern) 
            ? currentReport[`work_with_${user.mind_pattern.toLowerCase()}`] 
            : '';

        setTextReport(currentTextReport || defaultTextReport);
    }, [reports, loggedUser, user.mind_pattern, setTextReport])

    let mind_pattern_data = null;
    if (mind_pattern && mindPatternsAreas?.items?.size > 0) {
        mind_pattern_data =
            <div className="d-flex gap-10">
                {mind_pattern.split("").map((mp, k) => {
                    let mpItems = mindPatternsAreas.items.find(item => item.code === mp);
                    return (
                        <div key={`${k}_${mp}`} className={`rounded-circle mind-pattern-area mind-pattern-area-sm ${mpItems.code !== 'A' ? 'text-white' : ''} bg-${mpItems.name.toLowerCase()}`}>
                            {mp.toUpperCase()}
                        </div>
                    )
                })}
            </div>
    }

    let mind_pattern_data_expanded = null;
    if (mind_pattern && mindPatternsAreas?.items?.size > 0) {
        mind_pattern_data_expanded =
            <div className="d-flex justify-content-around gap-10">
                {mind_pattern.split("").map((mp, k) => {
                    const area = mindPatternsAreas.items.find(mpArea => { return mpArea.code.toLowerCase() === mp.toLowerCase() });
                    return (
                        <div key={`${k}_${mp}`} className='text-center'>
                            <div className={`mb-1 mx-auto rounded-circle mind-pattern-area ${area.code !== 'A' ? 'text-white' : ''} bg-${area.name.toLowerCase()}`} style={{ width: '42px', height: '42px' }}>
                                <img className={area.code !== 'A' ? 'img-brightness' : ''}
                                    src={area.icon}
                                    alt={area.name} />
                            </div>
                            <div>
                                <small className='font-weight-semibold'>
                                    {area.name}
                                </small>
                            </div>
                        </div>
                    )
                })}
            </div>
    }

    return (
        <>
            <div className='border-bottom'>
                <div className='d-flex align-items-xl-center align-items-start'>
                    <Row className="mx-0 justify-content-between align-items-center flex-fill py-3" style={{ cursor: "pointer" }} onClick={toggleCollapsed}>
                        <Col lg="4">
                            <div className="d-flex align-items-center py-3">
                                <div className="mr-2 my-1"><img src={avatar} width="48" height="auto" alt={first_name + ' ' + last_name} /></div>
                                <div>
                                    <div className='d-flex'>
                                        <h2 className="h6 font-weight-semibold mb-0">{first_name + ' ' + last_name}</h2>
                                        {isLeader === 1 && <img className="talents-icon-arrow ml-1 align-self-start" src={icon_team_leader} width="16" height="auto" alt="Team Leader" />}
                                    </div>
                                    {rol && <p className="mb-0">{rol}</p>}
                                    <a onClick={e => e.stopPropagation()} href={'mailto:' + email} target="_blank" rel='noreferrer' className="d-block text-muted small">{email}</a>
                                </div>
                            </div>
                        </Col>
                        <Col xs="12" lg="auto" className='flex-fill'>
                            <Collapse isOpen={collapsed} className="fade">
                                <Row className='align-items-center'>
                                    <Col>
                                        {hasNoTalents
                                            ?
                                            <div className="d-flex justify-content-center align-items-center h-100">
                                                <p className="m-0">Not Completed</p>
                                            </div>
                                            :
                                            <ReportTT collapsed={true} user_finded={user} />
                                        }
                                    </Col>
                                    <Col>
                                        {!mind_pattern_data
                                            ?
                                            <div className="mind-patterns-content d-flex justify-content-center justify-content-lg-end py-3 align-items-end h-100">
                                                <p className="m-0">Not Completed</p>
                                            </div>
                                            :
                                            <div className="mind-patterns-content d-flex justify-content-center justify-content-lg-end py-3">{mind_pattern_data}</div>
                                        }
                                    </Col>
                                </Row>
                            </Collapse>
                        </Col>
                    </Row>
                    <div className='px-0 py-3'>
                        <Button onClick={toggleCollapsed} color="link" className={`text-muted ${collapsed ? '' : 'fa-flip-vertical'}`}>
                            <svg xmlns="http://www.w3.org/2000/svg" fill='currentColor' viewBox="0 0 14 7" width="14" height="7">
                                <path d="M13,1.1L7.4,6.8C7.3,6.8,7.3,6.9,7.2,6.9c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1-0.1-0.2-0.1L1,1.1
                                C0.9,1,0.8,0.9,0.8,0.8S0.9,0.5,1,0.4c0.1-0.1,0.2-0.2,0.4-0.2c0.1,0,0.3,0.1,0.4,0.2L7,5.6l5.2-5.2c0.1-0.1,0.1-0.1,0.2-0.1
                                c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0,0.2,0S13,0.3,13,0.4c0.1,0.1,0.1,0.1,0.1,0.2c0,0.1,0,0.1,0,0.2c0,0.1,0,0.1,0,0.2
                                C13.1,1,13.1,1.1,13,1.1z"/>
                            </svg>
                        </Button>
                    </div>
                </div>
                <Collapse isOpen={!collapsed} className="fade">
                    <Row className='mx-0' style={{ minHeight: 486 }}>
                        <Col lg={8} className='mb-3' style={{ minHeight: 243 }}>
                            <div className='border rounded p-3 h-100'>
                                <h5 className="font-weight-bold mb-2">Thinking Talents</h5>
                                {hasNoTalents
                                    ?
                                    <div className="d-flex justify-content-center align-items-center h-100">
                                        <p className="m-0">Not Completed</p>
                                    </div>
                                    :
                                    <ReportTT user_finded={user} />
                                }
                            </div>
                        </Col>
                        <Col lg={4} className='mb-3' style={{ minHeight: 243 }}>
                            <div className='border rounded p-3 h-100'>
                                <h5 className="font-weight-bold mb-2">Mind Pattern</h5>
                                {!mind_pattern_data_expanded
                                    ?
                                    <div className="d-flex justify-content-center align-items-center h-100">
                                        <p className="m-0">Not Completed</p>
                                    </div>
                                    :
                                    <>
                                        <div className='py-3'>
                                            {mind_pattern_data_expanded}
                                        </div>

                                        {(loggedUser.mind_pattern && loggedUser.id === user.id)
                                            ? <p className="text-center mt-3"><Link to='/mind-patterns'>View your Mind Pattern results</Link></p>
                                            : <>
                                                {textReport && <div>
                                                    <p dangerouslySetInnerHTML={{ __html: textReport }}></p>
                                                </div>}
                                                {!loggedUser.mind_pattern && user.mind_pattern &&
                                                    <p className="text-muted small pt-2">Complete your own Mind Pattern assessment to get a more detailed explanation on the interaction between you and this team member.</p>
                                                }
                                            </>
                                        }
                                    </>
                                }
                            </div>
                        </Col>
                    </Row>
                </Collapse>
            </div>
        </>
    )
}
ResumeMember.defaultProps = {
    isLeader: 0,
};